import React, { Ref } from 'react';
import { HTMLFieldProps, connectField, filterDOMProps } from 'uniforms';

export type TextFieldProps = HTMLFieldProps<
  string,
  HTMLDivElement,
  { inputRef?: Ref<HTMLInputElement> }
>;

function Text({
  autoComplete,
  disabled,
  id,
  inputRef,
  label,
  name,
  onChange,
  placeholder,
  readOnly,
  type = 'text',
  value,
  ...props
}: TextFieldProps) {
  return (
    <div {...filterDOMProps(props)} className="flex items-center gap-4 py-2">
      {/* {label && (
        <label htmlFor={id} className="min-w-[200px]">
          {label}
        </label>
      )} */}

      <input
        autoComplete={autoComplete}
        disabled={disabled}
        id={id}
        name={name}
        onChange={(event) => onChange(event.target.value)}
        // placeholder={placeholder}
        placeholder={`${label?.toString()}`}
        readOnly={readOnly}
        ref={inputRef}
        type={type}
        value={value ?? ''}
        className="h-[55px] w-full rounded border border-gray-400 px-[15px] text-sm focus:outline-none"
      />
    </div>
  );
}

export default connectField<TextFieldProps>(Text, { kind: 'leaf' });
